export enum ProcessingResolutionEnum {
	HIGH = 'ALTA',
	MEDIUM = 'MEDIA',
	LOW = 'BAIXA',
}
